import { render, staticRenderFns } from "./CampaignDetailsView.vue?vue&type=template&id=72f61d1a&scoped=true"
import script from "./CampaignDetailsView.vue?vue&type=script&lang=js"
export * from "./CampaignDetailsView.vue?vue&type=script&lang=js"
import style0 from "./CampaignDetailsView.vue?vue&type=style&index=0&id=72f61d1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f61d1a",
  null
  
)

export default component.exports